import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { UserProjectRequest } from 'services/person/request/request.types';
import { useGetUserProjectRequestsMutation } from 'services/person/request/request.endpoint';
import { useApiToast } from 'components/Toaster';
import { Person } from 'services/person/person.types';

export default function useRequestsTabVM(person: Person) {

    const [activeTab, setActiveTab] = useState(0);
    const navigate = useNavigate();
    let { personId, projectId } = useParams();
    const [requests, setRequests] = useState<UserProjectRequest[]>([]);
    const { showApiToast, showErrorToast } = useApiToast();

    const [getUserProjectRequest, { isLoading: isGetUserProjectRequestLoading, isError: isGetUserProjectRequestError, isSuccess: isGetUserProjectRequestSuccess, error: projectRequestsError, data: projectRequestsResponse }] =
        useGetUserProjectRequestsMutation();

    useEffect(() => {
        getUserProjectRequest({ id: person?.projects[0].id as number });
    }, [getUserProjectRequest, person?.projects]);

    useEffect(() => {
        if (isGetUserProjectRequestLoading) return;
        if (isGetUserProjectRequestError && projectRequestsError) {
            showErrorToast(projectRequestsError, {
                message: 'Erreur de chargement des demandes'
            });
            return;
        }
        if (isGetUserProjectRequestSuccess && projectRequestsResponse) {
            setRequests(projectRequestsResponse.data);
        }
    }, [isGetUserProjectRequestLoading, isGetUserProjectRequestError, isGetUserProjectRequestSuccess, projectRequestsError, projectRequestsResponse, requests, showErrorToast]);

    function setPersonProjectRequestToEdit(request: UserProjectRequest) {
        if (!projectId) return;
        navigate(`${request.id}/edit`)
    }

    return {
        isGetUserProjectRequestLoading,
        activeTab,
        setActiveTab,
        requests,
        personId,
        projectId,
        setPersonProjectRequestToEdit
    };
}
